/* unplugin-vue-components disabled */import { render } from "./widgets.vue?vue&type=template&id=4eac3def&scoped=true"
import script from "./widgets.vue?vue&type=script&lang=js"
export * from "./widgets.vue?vue&type=script&lang=js"

import "./widgets.vue?vue&type=style&index=0&id=4eac3def&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eac3def"],['__file',"src/components/widgets/widgets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4eac3def"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4eac3def', __exports__)) {
    api.reload('4eac3def', __exports__)
  }
  
  module.hot.accept("./widgets.vue?vue&type=template&id=4eac3def&scoped=true", () => {
    api.rerender('4eac3def', render)
  })

}


export default __exports__